import { ArticleStatusType } from "../../models/article"

export const draftStatuses = [ArticleStatusType.Draft, ArticleStatusType.Approval]
export const publishedStatuses = [ArticleStatusType.Active]

export const isDraft = (status: ArticleStatusType) => draftStatuses.includes(status)
export const isPublished = (status: ArticleStatusType) => publishedStatuses.includes(status)
